:current-page.sync="pageNum" <template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>渠道</el-breadcrumb-item>
            <el-breadcrumb-item>店铺账单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table :data="list" border>
            <el-table-column prop="settle_no" label="账单编号" width="150"></el-table-column>
            <el-table-column prop="date" label="日期" min-width="100"></el-table-column>
            <el-table-column prop="channel_name" label="渠道名称" min-width="100"></el-table-column>
            <el-table-column prop="order_totals" label="订单金额" min-width="100"></el-table-column>
            <el-table-column prop="express_totals" label="运费" min-width="100"></el-table-column>
            <el-table-column prop="supplier_totals" label="供应金额" min-width="100"></el-table-column>
            <el-table-column prop="return_totals" label="退款金额" min-width="100"></el-table-column>
            <el-table-column prop="result_totals" label="应结算金额" min-width="100"></el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [],
                isLoad: false,
                pageNum: 0,
                pageSize: 20,
                total: 0,
                page: 1,
                // 查询
                item: {
                    state: ''
                },
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/channel/bill', Object.assign({
                    id: this.$route.query.id,
                    page: this.page,
                }, this.item))
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.list.data
                        // 页数 page
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            look(id) {
                this.$router.push({
                    path: '/channel/bill.html',
                    query: {
                        id: id
                    }
                });
            },
            // 传一个ID跳转到edit页面，进行编辑
            sizeReload(val) {
                this.pageSize = val
                  this.loadList()
            },
            pageReload(val) {
                this.page = val
                  this.loadList()
            },
            // 搜索查询
            submit() {
                this.pageNum = 1
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/admin/finance/listExport', this.item)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '财务对账单导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        },

    }
</script>
<style scoped>

</style>
